export default "__VITE_ASSET__e047ad2d__"